<div class="container-fluid page">
  <div class="d-flex page__box p-3 mt-2">
    &nbsp; Track Your Harvest
    <div class="export_csv">
      <button
        class="clear_button_export"
        (click)="openDialogexport()"
        style="float: right"
        mat-raised-button
        color="primary"
      >
        Export
      </button>
    </div>
  </div>
  <div class="page__content shadow p-3">
    <div>
      <br />
      <div>
        <table class="firstTable">
          <tr>
            <!-- <th class="FirstTh">Total number of Farmers</th>&nbsp;&nbsp;&nbsp; -->
            <th class="FirstTh">Farmers harvested this month</th>
            &nbsp;&nbsp;&nbsp;
            <th class="FirstTh">Farmers harvested previous month</th>
          </tr>
          <tr style="height: 50px">
            <!-- <td class="FirstTd">{{avgUser.totalUser}}</td>&nbsp;&nbsp;&nbsp; -->
            <td class="FirstTd">{{ avgUserCount.currentMonthCount }}</td>
            &nbsp;&nbsp;&nbsp;
            <td class="FirstTd">{{ avgUserCount.previousMonthCount }}</td>
          </tr>
        </table>
      </div>

      <mat-card>
        <div class="example-header" *ngIf="filtershow">
          <mat-form-field
            class="full-width-field"
            style="width: 50% !important"
          >
            <input
              matInput
              [(ngModel)]="searchData"
              (change)="changeFn($event)"
              placeholder="Search"
            /> </mat-form-field
          >&nbsp;
          <button
            type="submit"
            (click)="applyFilter(true)"
            class="btn btn-primary mat-primary search_bar"
          >
            <mat-icon class="search_bar_icon">search</mat-icon>
          </button>
          <button
            type="submit"
            (click)="addHarvestCrop(true)"
            class="btn btn-primary mat-primary pull-right"
          >
            Add Harvest Crop
          </button>
          <hr />

          <mat-form-field>
            <!-- <label for="exampleInputEmail1">The range date</label> -->
            <input
              matInput
              type="text"
              name="daterange"
              placeholder="Date Range"
              [min]="minDate"
              [locale]="{ applyLabel: 'ok', format: 'DD/MM/YYYY' }"
              autocomplete="off"
              [max]="maxDate"
              [alwaysShowCalendars]="true"
              ngxDaterangepickerMd
              [(ngModel)]="sharedate"
              [showCustomRangeLabel]="true"
              [ranges]="ranges"
              (change)="onDateRangeChanged(sharedate)"
            /> </mat-form-field
          >&nbsp;
          <mat-form-field (click)="suche()">
            <mat-select
              [formControl]="bankMultiCtrl"
              [(ngModel)]="statedata"
              ngDefaultControl
              placeholder="State"
              [multiple]="true"
              #multiSelect
              noEntriesFoundLabel="'no matching country found'"
            >
              <mat-option>
                <ngx-mat-select-search
                  id="search1"
                  [showToggleAllCheckbox]="true"
                  (ngModelChange)="filterMyOptions($event); notFound()"
                  [toggleAllCheckboxIndeterminate]="isIndeterminate"
                  [toggleAllCheckboxChecked]="isChecked"
                  (toggleAll)="toggleSelectAll($event)"
                  [formControl]="bankMultiFilterCtrl"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option
                *ngFor="let bank of filteredBanksMulti | async"
                [value]="bank"
              >
                {{ bank.stateName }}
              </mat-option>
            </mat-select> </mat-form-field
          >&nbsp;

          <mat-form-field (click)="sucheDistrict()">
            <mat-select
              [formControl]="districtMultiCtrl"
              [(ngModel)]="districtdata"
              ngDefaultControl
              placeholder="District"
              [multiple]="true"
              #multiSelect
            >
              <mat-option>
                <ngx-mat-select-search
                  id="search1"
                  [showToggleAllCheckbox]="true"
                  [toggleAllCheckboxIndeterminate]="isIndeterminateDistrict"
                  [toggleAllCheckboxChecked]="isCheckedDistrict"
                  (toggleAll)="toggleSelectAlldistrict($event)"
                  [formControl]="districtMultiFilterCtrl"
                  (ngModelChange)="notFoundDistrict()"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option
                *ngFor="let district of selectDistrict"
                [value]="district"
              >
                {{ district }}
              </mat-option>
            </mat-select> </mat-form-field
          >&nbsp;&nbsp;

          <button
            class="btn btn-primary mat-primary clear_button pull-right"
            style="margin-top: 12px"
            (click)="clearFilter()"
          >
            Clear Filter
          </button>
          <button
            type="submit"
            (click)="applyFilter(true)"
            style="margin-top: 12px; margin-right: 10px"
            class="btn btn-primary mat-primary pull-right"
          >
            Apply Filter
          </button>
        </div>

        <mat-chip-list #chipList aria-label="Filter selection">
          <mat-chip
            *ngFor="let filter of matChipArray; let i = index"
            [selectable]="selectable"
            [removable]="removable"
            (removed)="remove(i, filter.tag)"
          >
            {{ filter.name }}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
          </mat-chip>
        </mat-chip-list>

        <div class="text_filter_data" *ngIf="exportcsvdata">
          <p *ngIf="length == 0">
            There's no record found with the given criteria, please try again
            refining your search and filters
          </p>
        </div>
      </mat-card>

      <div class="mat-elevation-z8 position-relative" style="margin-top: 15px">
        <mat-table #table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="images">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Images
            </mat-header-cell>
            <mat-cell *matCellDef="let HarvestDetailList">
              <img
                *ngIf="HarvestDetailList.imageUrl"
                [src]="HarvestDetailList.imageUrl"
                style="width: 50px; height: 50px"
              />
              <img
                *ngIf="!HarvestDetailList.imageUrl"
                src="../../assets/no-image-icon.png"
                style="width: 50px; height: 50px"
              />
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="districtName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              District
            </mat-header-cell>
            <mat-cell *matCellDef="let HarvestDetailList" class="userNameCol">
              <div>{{ HarvestDetailList.districtName }}</div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="crop">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Crop
            </mat-header-cell>
            <mat-cell *matCellDef="let HarvestDetailList" class="userNameCol">
              <div>{{ HarvestDetailList.cropName }}</div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="farmerName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Farmer</mat-header-cell
            >
            <mat-cell *matCellDef="let HarvestDetailList"
              ><a
                title="View Profile"
                class="userNameCol"
                (click)="openDialog(HarvestDetailList)"
              >
                <div>{{ HarvestDetailList.farmerName }}</div>
              </a></mat-cell
            >
          </ng-container>
          <ng-container matColumnDef="stateName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              State
            </mat-header-cell>
            <mat-cell *matCellDef="let HarvestDetailList" class="userNameCol">
              <div>{{ HarvestDetailList.stateName }}</div>
            </mat-cell>
          </ng-container>
          <!-- <ng-container matColumnDef="totalTree">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Total Trees
            </mat-header-cell>
            <mat-cell *matCellDef="let HarvestDetailList" class="userNameCol">
              <div>{{ HarvestDetailList.totalTree }}</div>
            </mat-cell>
          </ng-container> -->

          <!-- <ng-container matColumnDef="treeHarvested">
            <mat-header-cell *matHeaderCellDef mat-sort-header
              >Trees Harvested
            </mat-header-cell>
            <mat-cell *matCellDef="let HarvestDetailList" class="userNameCol">
              {{ HarvestDetailList.treeHarvested }}
            </mat-cell>
          </ng-container> -->

          <ng-container matColumnDef="harvest">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Harvest
            </mat-header-cell>
            <mat-cell *matCellDef="let HarvestDetailList">
              {{
                HarvestDetailList.cropName == "Coconut"
                  ? HarvestDetailList.harvest
                  : HarvestDetailList.quantity
              }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="createdOn">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Date
            </mat-header-cell>
            <mat-cell *matCellDef="let HarvestDetailList">
              {{ HarvestDetailList.createdOn | date : "dd/MM/yyyy" }}
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>

        <div>
          <mat-paginator
            [length]="length"
            [pageIndex]="pageIndex"
            (page)="getServerData($event)"
            [pageSizeOptions]="[10, 20, 50]"
            showFirstLastButtons
            aria-label=""
            class="pagination"
          >
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid page" *ngIf="Viewprofile">
  <div class="d-flex page__box p-3 mt-2">
    <img src="./assets/arrow_logo.png" class="arrow" />&nbsp; User Profile
  </div>
  <div class="page__content shadow p-3">
    <div class="row">
      <div class="col-md-12">
        <!-- <button type="button" style="background-color: red;
                  border-color: #0d6efd;" (click)="showViews(1)"  class="btn btn-primary rejbutt">Back</button> -->
        <!-- <mat-card >
              <img mat-card-image src="https://material.angular.io/assets/img/examples/shiba2.jpg" alt="Photo of a Shiba Inu" style="height:100px;width:100px">
           </mat-card> -->
        <!-- <div class="col-md-2 profile_image">
             
             <mat-card >
              <mat-card-title style="font-size: 20px !important;">Profile Piture</mat-card-title>
              <hr>
            <img mat-card-image src="./assets/userImg.png" >
         </mat-card>
        </div> -->
        <div class="col-md-1"></div>
        <div class="profile_details">
          <!--class="profile_details"-->
          <mat-card>
            <h5></h5>

            <div
              class="profile_image"
              style="float: right; margin-top: 12px; margin-right: 100px"
            >
              <!-- <h5 style="margin-left: 20px;">Profile Photo</h5> -->
              <!-- <img mat-card-image src="./assets/userImg.png" > -->
              <!-- <img mat-card-image src="{{profile_Image}}" > -->
              <div *ngIf="avtar; else loggedOut">
                <img mat-card-image src="./assets/userImg.png" />
              </div>
              <ng-template #loggedOut>
                <img mat-card-image src="{{ profile_Image }}" />
              </ng-template>
              <div *ngIf="documentStatus == 'Verified'">
                <img
                  src="./assets/verified.png"
                  style="height: 39px; margin-left: 13px"
                />
                <p class="text_verified">
                  <b style="font-size: 18px">Verified</b>
                </p>
              </div>
            </div>

            <div>
              <div *ngIf="datashowfarmer">
                <p><b>Farmer Name</b> : {{ personName }}</p>
                <p><b>Role</b> : {{ role }}</p>
                <p><b>Village</b> : {{ village }}</p>
                <p><b>Taluk</b> : {{ taluk }}</p>
                <p><b>District</b> : {{ district }}</p>
                <p><b>State</b> : {{ states }}</p>
                <p><b>Mobile Number</b> : {{ phoneNo }}</p>
                <!-- <p><b>Mandi</b>          : {{mandi}}</p> -->
                <p><b>No Of Trees</b> : {{ numberOfTrees }}</p>
                <p><b>Types of Trees</b> : {{ treeType }}</p>
                <p><b>Customer Id </b> : {{ treeType }}</p>
              </div>
              <!---For farmer -->
              <!--For Traders -->
              <div *ngIf="datashowtrader">
                <p><b>Trader Name</b> : {{ personName }}</p>
                <p><b>Company </b> : {{ personName }}</p>
                <p><b>Role</b> : {{ role }}</p>
                <p><b>Address</b> : {{ address }}</p>
                <p><b>District</b> : {{ district }}</p>
                <p><b>State</b> : {{ states }}</p>
                <p><b>Mobile Number</b> : {{ phoneNo }}</p>
                <p><b>Email</b> : {{ email }}</p>
                <p><b>Mandi</b> : {{ mandi }}</p>
                <p>
                  <b>Commodity trade interested</b>: {{ commTradeInterest }}
                </p>
                <p><b>Frequency for requirement</b> : {{ reqFrequency }}</p>
                <p><b>About the trader</b> : {{ aboutUs }}</p>
              </div>
            </div>
            <!--For Traders -->
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>
